/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-HoverCardExample{margin-top:30px;text-align:center}\n"}]);